//import $ from 'jquery';
import * as Cookies from 'js-cookie';
//import MegaNav from '../components/MegaNav';
import MobileNav from '../components/MobileNav';
//import ResponsiveBackgroundImage from '../components/ResponsiveBackgroundImage';
//import ExternalLinkSpeedBumps from '../components/ExternalLinkSpeedBumps';
import throttle from 'lodash.throttle';
//import debounce from 'lodash.debounce';

export default {
    init() {
        // JavaScript to be fired on all pages
        this.initMobileNav();
        this.initFixedNav();


        /**
        *
        * Class toggle for flex module info boxes
        *
        */

        let flexModuleInfoToggle = $('.flex-module-info-toggle');
        let flexModuleInfo = $('.flex-module-info');

        flexModuleInfoToggle.on('click', function(){
            flexModuleInfo.toggle();
        });


        // Normalize carousel slide heights
        function normalizeSlideHeights() {
            $('.testimonialSlider .carousel').each(function() {
                var items = $('.carousel-item', this);
                var itemsParent = $('.carousel-item', this);
                // reset the height
                items.css('min-height', 0);
                // set the height
                var maxHeight = Math.max.apply(
                    null,
                    items
                        .map(function() {
                            return $(this).outerHeight();
                        })
                        .get()
                );
                itemsParent.css('min-height', maxHeight + 'px');
            });
        }

        $(window).on(
            // 'load resize orientationchange',
            'load',
            normalizeSlideHeights
        );



        // Elements with the data property 'responsive-background-image' should have an image as a direct child that
        // is hidden and used by ResponsiveBackgroundImage to apply as a background image.
        // let elements = document.querySelectorAll('[data-responsive-background-image]');
        // for (let i = 0; i < elements.length; i++) {
        //   new ResponsiveBackgroundImage(elements[i]);
        // }

        let searchOpen = false;
        let $searchInput = $('#globalSearchForm__input');
        let $searchOpenBtn = $('#globalSearchForm__btn');
        let $searchCloseBtn = $('#globalSearFrom__btn--close');
        let $searchSubmitBtn = $('#globalSearchForm__btn--open');

        $searchOpenBtn.click(function(event) {
            if (searchOpen === false) {
                event.preventDefault();
                $('.layout-search__form').addClass('open');
                $('.layout-search__drawer').addClass('open');
                $searchInput.focus();
                $searchOpenBtn.hide();
                $searchSubmitBtn.show();
                searchOpen = true;
            }
        });

        $searchCloseBtn.click(function (event) {
            if (searchOpen === true) {
                event.preventDefault();
                $('.layout-search__form').removeClass('open');
                $('.layout-search__drawer').removeClass('open');
                //$searchInput.focus();
                $searchOpenBtn.show();
                $searchSubmitBtn.hide();
                searchOpen = false;
            }
        });

        /*
            Ask Hannah CTA
        */
        // max progress
        let getMax = function () {
            return (
                $(document).height() -
                $(window).height() -
                $('.layout-footer').height()
            );
        };

        let currentTimestamp = Date.now();
        //let OmissionDuration = 172800000;  // 2 days
        let OmissionDuration = 86400000; // 1 day
        let ctaTimestamp = Number(localStorage.getItem('time-cta-last-shown'));
        let ctaScrollPoint = getMax() * 0.25;

        const slideCTA = $('.slide-in-cta');
        const slideCTAClose = $('.slide-in-cta .slide-in-cta__close');

        /*
            Show slide cta if local storage item comparison checks out
            and if past the prescribed scroll point
        */
        if (currentTimestamp - ctaTimestamp >= OmissionDuration) {
            if ( $(window).width() > 768 ) {
                $(window).scroll(function () {
                    if ($(window).scrollTop() > ctaScrollPoint) {
                        slideCTA.fadeIn();
                    } else {
                        slideCTA.fadeOut();
                    }
                });
            }
        }

        // close slide cta and set timestamp for 'time-cta-last-shown'
        slideCTAClose.on('click', function (e) {
            slideCTA.css('visibility', 'hidden');
            /*
                Set visibility hidden because the timestamp check only works on page load
                This prevents the cta from showing after it's closed (and re-showing on scroll)
                The local storage timestamp check will then prevent the cta from showing on subsequent pages.
            */
            localStorage.setItem('time-cta-last-shown', currentTimestamp);
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Set a cookie when a visitor dismisses an alert/notification
        $('.alert-notification').on('close.bs.alert', function (event) {
            let element = event.target;
            Cookies.set('notification_' + element.dataset.notification, Date.now(), {expires: new Date(element.dataset.expiration * 1000)});
        });

        //let throttledScrollBackToTop = function scrollFunction() {
        //let backToTopButton = $('#backTop');
        // let backToTopWindowOffset = 105;
        // if ($(this).scrollTop() > backToTopWindowOffset) {
        //   // Show the back-to-top link
        //   backToTopButton.fadeIn().css('opacity', 1).addClass('active');
        // } else {
        //   // Hide the back-to-top link
        //   backToTopButton.fadeOut().css('opacity', 0).removeClass('active');
        // }
        //};

        // Handle back-to-top button show/hide on scroll
        //$(window).on('scroll', throttle(throttledScrollBackToTop, 300));

        // Fixed element on scroll
        // let throttledFixedHeader = function scrollFunction() {
        //   let bodyElement = $('body');
        //   let fixedTopElement = bodyElement.find('.layout-navbar');
        //   let fixedTopElementWindowOffset = ($(window).width() > 991) ? 50 : 0;
        //
        //   if ($(this).scrollTop() > fixedTopElementWindowOffset) {
        //     fixedTopElement.addClass('fixed-top');
        //     bodyElement.addClass('fixed-navbar-on');
        //   } else {
        //     fixedTopElement.removeClass('fixed-top');
        //     bodyElement.removeClass('fixed-navbar-on');
        //   }
        // };

        // Handle fixed position navbar element on scroll
        //$(window).on('scroll load', throttle(throttledFixedHeader, 100));

        // ExternalSpeedBumps - show browser confirm for links not on whitelisted URLs
        // let SpeedBumpLinks = new ExternalLinkSpeedBumps([
        //   'rakacreative.com',
        // ], 'Notice: You are leaving this website.\n\nClick Ok to continue or Cancel to go back.');

        // SpeedBumpLinks.registerClickEvent();

    },

    initMobileNav() {
        new MobileNav();
    },

    initFixedNav() {
        let navbar = document.body.querySelector('.layout-navbar');

        if (navbar.classList.contains('layout-navbar--condensed')) {
            navbar.dataset.initiallyCondensed = true;
        }

        window.addEventListener('scroll', throttle(this.handleFixedNavScroll.bind(this), 100), {passive: true});
        this.handleFixedNavScroll();
    },


    handleFixedNavScroll() {
        /*
            This targets the .layout-navbar but could easily be adapted to
            incorporate the entire .layout-header. CSS would need to be altered/moved to
            fully put that change in effect.
        */
        const condensed = 'layout-navbar--condensed';
        const fixed = 'layout-navbar--fixed';
        const navFixed = 'fixed-navbar-on';

        let body = document.body;
        let navbar = body.querySelector('.layout-navbar');
        let fixedAfter = document.querySelector('.layout-header').offsetHeight;

        if (document.documentElement.scrollTop > fixedAfter) {
            navbar.classList.add(condensed, fixed); // uncomment if planning on using condensed navbar on scroll
            body.classList.add(navFixed);
        } else {
            navbar.classList.remove(fixed);
            if (navbar.dataset.initiallyCondensed === undefined) { // uncomment if planning on using condensed navbar on scroll
                navbar.classList.remove(condensed);
            }
            body.classList.remove(navFixed);
        }
    },

};
